import { readEnv } from "@repo/helpers";
import { type FC, useMemo } from "react";
import { Icons } from ".";
import { formatFileSize } from "../helpers";
import * as Styled from "./Downloads.styled";

export type DownloadProps = {
    name: string;
    dateCreated?: Date;
    fileSize?: number;
    mimeType: string;
    downloadPath?: string;
    isExternalUrl?: boolean;
};

const dateTimeFormat = new Intl.DateTimeFormat("cs-CZ", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
});

export const Downloads: FC<DownloadProps> = ({
    name,
    dateCreated,
    fileSize,
    mimeType,
    downloadPath,
    isExternalUrl,
}) => {
    const sizeText = formatFileSize(fileSize);
    const cleanedMime = mimeType.replace(/application\//g, "");
    const href = useMemo(
        () => (isExternalUrl ? downloadPath : `${readEnv("VITE_API_BASE_URL")}/${downloadPath}`),
        [downloadPath, isExternalUrl],
    );

    return (
        <Styled.Wrapper direction="row">
            <Styled.DownloadLink download target="_blank" href={href}>
                <Styled.DownloadButton color="primary" disabled={!downloadPath}>
                    <Icons.Download sx={{ width: "1.6rem", height: "1.9rem" }} color="inherit" />
                </Styled.DownloadButton>
            </Styled.DownloadLink>
            <Styled.InfoStack>
                <Styled.NameRow>
                    <Styled.FileLink download href={href} target="_blank" variant="light">
                        {name}
                    </Styled.FileLink>
                </Styled.NameRow>
                <Styled.Meta light>
                    {dateCreated && dateTimeFormat.format(new Date(dateCreated))} ({fileSize ? `${sizeText}, ` : ""}
                    {cleanedMime})
                </Styled.Meta>
            </Styled.InfoStack>
        </Styled.Wrapper>
    );
};
